import shortid from 'shortid';
import find from 'lodash/find';
import difference from 'lodash/difference';
import { put, fork, take, select } from 'redux-saga/effects';
import * as actions from './actions';
import * as itemActions from '../actions';


const INITIAL_STATYS_TYPE = 1;
const FINAL_STATYS_TYPE = 4;


function getFreeStatusType(statuses, statusOptions) {
  const diff = difference(statusOptions.map(x => x.id), statuses.map(x => x.statusId));
  return find(statusOptions, x => x.id === diff[0]);
}

function* init() {
  while (true) {
    const { statuses } = yield take(actions.INIT.BEGIN);
    statuses.forEach((status) => {
      status.$$localId = shortid.generate();
    });
    if (!find(statuses, x => x.type === INITIAL_STATYS_TYPE)) {
      statuses.push({
        $$localId: shortid.generate(),
        statusId: 0,
        type: INITIAL_STATYS_TYPE,
        color: 0,
        isDefault: false,
        isCompleteOnSprint: false,
        isCalculateSpentTime: false,
        order: 0,
      });
    }
    if (!find(statuses, x => x.type === FINAL_STATYS_TYPE)) {
      statuses.push({
        $$localId: shortid.generate(),
        statusId: 0,
        type: FINAL_STATYS_TYPE,
        color: 0,
        isDefault: true,
        isCompleteOnSprint: false,
        isCalculateSpentTime: false,
        order: 1,
      });
    }

    const defaultStatus = find(statuses,  x => x.type === FINAL_STATYS_TYPE && x.isDefault);
    const defaultStatusId = defaultStatus && defaultStatus.statusId;
    yield put(actions.setStatuses.begin({ statuses }));
    yield put(actions.init.end({ defaultStatusId }));
    yield put(itemActions.checkValidation.begin());
  }
}

function* setStatuses() {
  while (true) {
    const { statuses } = yield take(actions.SET_STATUSES.BEGIN);
    const initialStatus = statuses.filter(x => x.type === INITIAL_STATYS_TYPE)[0];
    const flowStatuses = statuses.filter(x => x.type !== INITIAL_STATYS_TYPE && x.type !== FINAL_STATYS_TYPE);
    const completedStatuses = statuses.filter(x => x.type === FINAL_STATYS_TYPE);
    flowStatuses.sort((a, b) => a.order - b.order);
    completedStatuses.sort((a, b) => a.order - b.order);
    yield put(actions.setStatuses.end({ initialStatus, flowStatuses, completedStatuses }));
  }
}

function* setStatusId() {
  while (true) {
    const { localId, statusId } = yield take(actions.SET_STATUS_ID);
    const { currentItem, statusOptions } = yield select(state => state.configuration.project.editor.itemType);
    const status = find(statusOptions, x => x.id === statusId);
    const statuses = currentItem.statusFlow.statuses.map((x) => {
      if (x.$$localId === localId) {
        return {
          ...x,
          statusId,
          color: status.color,
        };
      }
      return x;
    });
    yield put(actions.setStatuses.begin({ statuses }));
  }
}

function* setColor() {
  while (true) {
    const { localId, color } = yield take(actions.SET_COLOR);
    const { statuses: previosStatuses } = yield select(state => state.configuration.project.editor.itemType.currentItem.statusFlow);
    const statuses = previosStatuses.map((x) => {
      if (x.$$localId === localId) {
        return {
          ...x,
          color,
        };
      }
      return x;
    });
    yield put(actions.setStatuses.begin({ statuses }));
  }
}

function* setStatusType() {
  while (true) {
    const { localId, statusType } = yield take(actions.SET_STATUS_TYPE);
    const { statuses: previosStatuses } = yield select(state => state.configuration.project.editor.itemType.currentItem.statusFlow);
    const statuses = previosStatuses.map((x) => {
      if (x.$$localId === localId) {
        return {
          ...x,
          type: statusType,
        };
      }
      return x;
    });
    yield put(actions.setStatuses.begin({ statuses }));
  }
}

function* setDefaultStatus() {
  while (true) {
    const { statusId } = yield take(actions.SET_DEFAULT_STATUS);
    const { statuses: previosStatuses } = yield select(state => state.configuration.project.editor.itemType.currentItem.statusFlow);
    const statuses = previosStatuses.map((x) => {
      if (x.statusId === statusId) {
        return {
          ...x,
          isDefault: true,
        };
      }
      return {
        ...x,
        isDefault: false,
      };
    });
    yield put(actions.setStatuses.begin({ statuses }));
  }
}

function* setCompletedOnSprint() {
  while (true) {
    const { localId, value } = yield take(actions.SET_COMPLETED_ON_SPRINT);
    const { statuses: previosStatuses } = yield select(state => state.configuration.project.editor.itemType.currentItem.statusFlow);
    const statuses = previosStatuses.map((x) => {
      if (x.$$localId === localId) {
        return {
          ...x,
          isCompleteOnSprint: value,
        };
      }
      return x;
    });
    yield put(actions.setStatuses.begin({ statuses }));
  }
}

function* setCalculateSpentTime() {
  while (true) {
    const { localId, value } = yield take(actions.SET_CALCULATE_SPENT_TIME);
    const { statuses: previosStatuses } = yield select(state => state.configuration.project.editor.itemType.currentItem.statusFlow);
    const statuses = previosStatuses.map((x) => {
      if (x.$$localId === localId) {
        return {
          ...x,
          isCalculateSpentTime: value,
        };
      }
      return x;
    });
    yield put(actions.setStatuses.begin({ statuses }));
  }
}

function* addFlow() {
  while (true) {
    yield take(actions.ADD_FLOW);
    const { currentItem, statusOptions, statusBehaviours } = yield select(state => state.configuration.project.editor.itemType);
    const { statuses: previosStatuses } = currentItem.statusFlow;
    const statusType = getFreeStatusType(previosStatuses, statusOptions);
    if (statusType) {
      let statuses = [
        ...previosStatuses,
        {
          $$localId: shortid.generate(),
          statusId: statusType.id,
          type: statusBehaviours[0].id,
          color: statusType.color,
          isDefault: false,
          isCompleteOnSprint: false,
          isCalculateSpentTime: false,
        },
      ];
      let order = 0;
      statuses = statuses.map((x) => {
        if (x.type !== INITIAL_STATYS_TYPE && x.type !== FINAL_STATYS_TYPE) {
          return {
            ...x,
            order: ++order,
          };
        }
        return x;
      });
      yield put(actions.setStatuses.begin({ statuses }));
    }
  }
}

function* addCompleted() {
  while (true) {
    yield take(actions.ADD_COMPLETED);
    const { currentItem, statusOptions } = yield select(state => state.configuration.project.editor.itemType);
    const { statuses: previosStatuses } = currentItem.statusFlow;
    const statusType = getFreeStatusType(previosStatuses, statusOptions);
    if (statusType) {
      let statuses = [
        ...previosStatuses,
        {
          $$localId: shortid.generate(),
          statusId: statusType.id,
          type: FINAL_STATYS_TYPE,
          color: statusType.color,
          isDefault: false,
          isCompleteOnSprint: false,
          isCalculateSpentTime: false,
        },
      ];
      let order = 0;
      statuses = statuses.map((x) => {
        if (x.type === FINAL_STATYS_TYPE) {
          return {
            ...x,
            order: ++order,
          };
        }
        return x;
      });
      yield put(actions.setStatuses.begin({ statuses }));
    }
  }
}

function* remove() {
  while (true) {
    const { localId } = yield take(actions.REMOVE);
    const { statuses: previosStatuses } = yield select(state => state.configuration.project.editor.itemType.currentItem.statusFlow);
    const statuses = previosStatuses.filter(x => x.$$localId !== localId);
    yield put(actions.setStatuses.begin({ statuses }));
  }
}


export default function* statusFlow() {
  yield fork(init);
  yield fork(setStatuses);
  yield fork(setStatusId);
  yield fork(setColor);
  yield fork(setStatusType);
  yield fork(setDefaultStatus);
  yield fork(setCompletedOnSprint);
  yield fork(setCalculateSpentTime);
  yield fork(addFlow);
  yield fork(addCompleted);
  yield fork(remove);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/currentItem/statusFlow/saga.js